<template>
	<!-- 整个div都支持拖入下载 -->
	<div class="main-fn-all-body" @dragover.prevent="" @drop="drop">
		<!-- 固定的页头 在添加文件后会有额外的按钮  点击不触发上传文件  封装为组件5个页面公用并调用传入的不同的函数方法-->
		<mainFnHead
			:ext="ext"
			:isEmpty="!runner.files.length"
			@push="push"
			@clear="runner.clear()"
		></mainFnHead>
		<!-- 可拉伸的功能窗口 分为 初次进入时的页面 以及 导入文件后的功能页面 动态组件切换-->
		<component
			:is="mainFnBodyId"
			:titleH1="titleH1"
			:titleP="titleP"
			:imgSrc="imgSrc"
			:imgText="imgText"
			:shuchuStyle="shuchuStyle"
			:files="runner.files"
			:options="runner.options"
			:outputExt="shuchuGeShi"
			:ext="ext"
			:gxSelectArray="gxSelectArray"
			@push="push"
			@remove="remove"
			@openLimitBody1="openLimitBody1"
			ref="main_body"
			@globalApplication="globalApplication"
			:isGlobalApplicationOver="isGlobalApplicationOver"
			:nowCompressedFormat="'视频压缩'"
		></component>
	</div>
</template>

<script>
import mainFnHead from "./../../mycomponents/mainFnHead";
import mainFnBodySecend from "../../mycomponents/mainFnBodySecend";
import mainFnBodyFirst from "../../mycomponents/mainFnBodyFirst";
import VideoConverter from "../../lib/VideoConverter";
import {watchLocal} from "../../common/utils";
import {store} from "../../plugins";
const fs = require("fs");

export default {
	props: ["openLimitBody"],
	data() {
		return {
			runner: watchLocal("video-converter", new VideoConverter()),
			// mainFnBodyId: mainFnBodyFirst,
			titleH1: this.$t("videocompression"),
			titleP: this.$t("text037"),
			imgSrc: "pic_ship_big.png",
			imgText: "icon slt video.svg",
			shuchuStyle: this.$t("mp4style"),
			shuchuGeShi: "mp4",
			ext: "mp4,wmv,avi,flv,mkv,ts,MOV,mov,wtv,mxf,vro,mpg,mpeg,vob,3gp,3g2,asf,f4v,m4v",
			gxSelectArray: {
				video_bitrate_label: [
					this.$t("automatic"),
					"10%",
					"20%",
					"30%",
					"40%",
					"50%",
					"60%",
					"70%",
					"80%",
					"90%",
				],
				video_bitrate_value: [85, 10, 20, 30, 40, 50, 60, 70, 80, 90],
				video_fps_label: [this.$t("automatic"), 12.0, 15.0, 20.0, 23.97, 24.0, 25.0, 29.97, 30.0],
				video_fps_value: [0, 12.0, 15.0, 20.0, 23.97, 24.0, 25.0, 29.97, 30.0],
				music_bitrate_label: [
					this.$t("automatic"),
					64,
					96,
					this.$app.language ? 128 : "128(标准)",
					160,
					this.$app.language ? 192 : "192(较高)",
					256,
					this.$app.language ? 320 : "320(极高)",
				],
				music_bitrate_value: [0, 64, 96, 128, 160, 192, 256, 320],
				music_samplingrate_label: [this.$t("automatic"), 22.05, 44.1, 48],
				music_samplingrate_value: [0, 22.05, 44.1, 48],
			},
			isGlobalApplicationOver: true,
		};
	},
	computed: {
		mainFnBodyId() {
			return this.runner.files.length ? mainFnBodySecend : mainFnBodyFirst;
		},
		isVIPlimit() {
			return this.$app.VIPlevel;
		},
	},
	watch: {
		isVIPlimit(newval, oldval) {
			if (newval && oldval == 0) {
				for (let x of this.runner.files) {
					if (x.state == 6 || x.size > 2 * 1024 * 1024) {
						if (window.store.isYsOver) {
							x.state = 1;
						} else {
							x._timeOut = setInterval(function () {
								if (window.store.isYsOver) {
									x.state = 1;
									clearInterval(x._timeOut);
								}
								// console.log("还未清除");
							}, 1000);
						}
					}
				}
			} else if (newval == 0) {
				for (let x of this.runner.files) {
					if (
						x.is_gx_resolution ||
						x.is_video_bitrate ||
						x.is_video_fps ||
						x.is_music_bitrate ||
						x.is_music_samplingrate ||
						this.runner.options.global_application
					) {
						if (window.store.isYsOver) {
							x.is_gx_resolution = false;
							x.is_video_bitrate = false;
							x.is_video_fps = false;
							x.is_music_bitrate = false;
							x.is_music_samplingrate = false;
							this.runner.options.global_application = false;
						} else {
							x._timeOut2 = setInterval(function () {
								if (window.store.isYsOver) {
									x.is_gx_resolution = false;
									x.is_video_bitrate = false;
									x.is_video_fps = false;
									x.is_music_bitrate = false;
									x.is_music_samplingrate = false;
									this.runner.options.global_application = false;
									clearInterval(x._timeOut2);
								}
								// console.log("还未清除");
							}, 1000);
						}
					}
				}
			}
		},
	},
	components: {
		mainFnHead,
		mainFnBodyFirst,
	},
	methods: {
		remove(file) {
			this.runner.remove(file);
		},
		push(e) {
			console.log(e);
			this.$app.isDrOver = false;
			this.runner.addFiles(e).then(() => {
				// console.log("添加完成")
				this.$app.isDrOver = true;
			});
		},
		drop(e) {
			//拖拽上传
			console.log(e);
			let dropFiles = e.dataTransfer.files;
			// console.log(dropFiles);
			let todoList = Array.from(dropFiles);
			// console.log(todoList);
			if (dropFiles.length > 0) {
				let arr = [];
				arr = this.getAllFile(todoList);
				// console.log("arr2", arr);
				if (arr.length > 0) this.push(arr);
				else this.$toast.show(this.$t("pleaseselectvideoformatfile"));
			}
		},
		getAllFile(arr) {
			let a = [];
			let b = arr
				.map((item) => item.path)
				.filter((x) => {
					let e = hdapi.extname(x).toLowerCase();
					if (e) {
						return hdapi.hasExt(x, this.ext);
					} else {
						console.log("该文件为文件夹");
						let b = this.getInFileFiles(x);
						a.push(b);
						console.log("b", b);
						return false;
					}
				});
			a.push(...b);
			console.log("arr1", a);
			return a;
		},
		getInFileFiles(url) {
			let files = fs.readdirSync(url);
			console.log("files", files);
			let _this = this;
			let obj = {};
			for (let file of files) {
				var Path = hdapi.join(url, file);
				if (fs.statSync(Path).isDirectory()) {
					// recurse
					let a = _this.getInFileFiles(Path);
					obj = Object.assign(obj, a);
					continue;
				}
				if (!hdapi.hasExt(Path, this.ext)) continue;
				obj[Path] = Path;
				// console.log("curpath", curPath);
				/**
				 * fs.statSync同步读取文件夹文件，如果是文件夹，在重复触发函数
				 */
			}
			obj["url"] = url;
			return obj;
		},
		openLimitBody1() {
			this.$emit("openLimitBody");
		},
		globalApplication(file) {
			this.isGlobalApplicationOver = false;
			for (let x of this.runner.files) {
				if (file.is_gx_resolution) {
					x.is_gx_resolution = file.is_gx_resolution;
					x.gx_aspect_ratio = file.gx_aspect_ratio;
					x.gx_height = (x.height * x.gx_aspect_ratio) / 100;
					x.gx_width = (x.width * x.gx_aspect_ratio) / 100;
				} else {
					x.is_gx_resolution = file.is_gx_resolution;
				}
				if (file.is_video_bitrate) {
					x.is_video_bitrate = file.is_video_bitrate;
					x.video_bitrate = file.video_bitrate;
				} else {
					x.is_video_bitrate = file.is_video_bitrate;
				}
				if (file.is_video_fps) {
					x.is_video_fps = file.is_video_fps;
					x.video_fps = file.video_fps;
				} else {
					x.is_video_fps = file.is_video_fps;
				}
				if (file.is_music_bitrate) {
					x.is_music_bitrate = file.is_music_bitrate;
					x.music_bitrate = file.music_bitrate;
				} else {
					x.is_music_bitrate = file.is_music_bitrate;
				}
				if (file.is_music_samplingrate) {
					x.is_music_samplingrate = file.is_music_samplingrate;
					x.music_samplingrate = file.music_samplingrate;
				} else {
					x.is_music_samplingrate = file.is_music_samplingrate;
				}
			}
			this.isGlobalApplicationOver = true;
		},
	},
	created() {
		this.runner.options.compressLevel = 1;
		this.runner.options.global_application = false;
	},
};
</script>

<style>
.main-fn-all-body {
	width: 100%;
	height: 100%;
	/* background-color: rgb(167, 80, 167); */
}
</style>
